import React, { FC, useMemo, memo } from "react";
import Dropdown from "../../Dropdown/Dropdown";
import DropdownItem from "../../Dropdown/DropdownItem";
import { SelectFilterOption } from "../types";

type Props = {
  label: string;
  options: SelectFilterOption[];
  onSelect?: (value: string) => void;
  renderOption?: (option: SelectFilterOption) => void;
};

const SelectFilter: FC<Props> = ({
  label,
  options,
  onSelect,
  renderOption,
}) => {
  const filterOptions = useMemo(() => {
    if (renderOption) {
      return options.map((opt) => renderOption(opt));
    }
    return options.map((opt) => (
      <DropdownItem
        key={`filter-option-${opt.value}`}
        className="filter-option single-item"
        onClick={() => onSelect && onSelect(opt.value)}
      >
        {opt.label}
      </DropdownItem>
    ));
  }, [options, onSelect, renderOption]);
  return (
    <Dropdown
      label={label}
      dropdownClassName="filter"
      toggleClassName="filter-toggle"
      dropdownMenuClassName="filter-menu"
    >
      {filterOptions}
    </Dropdown>
  );
};

export default memo(SelectFilter);



// WEBPACK FOOTER //
// ./src/share/components/Filters/components/SelectFilter.tsx